// src/components/WhatsAppButton.tsx
import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

const WhatsAppButton: React.FC = () => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const phoneNumber = "+905452019060"; // Kendi numaranı yaz
  const message = t("whatsapp.greeting");

  return (
    <motion.div
      className="fixed z-50 flex items-center gap-3"
      style={{
        // iOS'ta ev tuşu/notch alanına gömülmesin diye safe-area payı +
        // sabit boşluk birlikte kullanılıyor. transform: translateZ(0) ile
        // ayrı bir GPU katmanına alınıyor - kaydırma sırasında Safari'nin
        // fixed öğeleri "kaydırma/titretme" davranışını azaltır.
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 1.25rem)",
        right: "calc(env(safe-area-inset-right, 0px) + 1.25rem)",
        transform: "translateZ(0)",
      }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, delay: 0.6 }}
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
    >
      <AnimatePresence>
        {hovered && (
          <motion.span
            initial={{ opacity: 0, x: 10, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 10, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="bg-white text-gray-800 text-sm font-semibold px-4 py-2 rounded-full shadow-lg whitespace-nowrap"
          >
            {t("whatsapp.cta")}
          </motion.span>
        )}
      </AnimatePresence>

      <motion.a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp'tan bize yazın"
        className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] shadow-xl"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
      >
        {/* Nabız gibi atan dikkat çekici halka */}
        <motion.span
          className="absolute inset-0 rounded-full bg-[#25D366]"
          animate={{ scale: [1, 1.8], opacity: [0.6, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeOut" }}
        />
        <FaWhatsapp className="relative text-white" style={{ fontSize: "2rem" }} />
      </motion.a>
    </motion.div>
  );
};

export default WhatsAppButton;
